import "../styles.css";

function Loader() {
    return <div className="lds-dual-ring"></div>
}

export default Loader;